export enum EnumApiCore {
  /** 提问 */
  homeworkQA = '/core/api/qa'
}
